import script from "./pagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./pagination.vue?vue&type=script&setup=true&lang=ts"

import "./pagination.vue?vue&type=style&index=0&id=ddf71b04&lang=scss&scoped=true"

import exportComponent from "/Users/macmini/builds/VJ28wZh6J/0/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddf71b04"]])

export default __exports__